module.exports = __webpack_public_path__ + "static/media/spray-decorating-001.1b497338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/spray-decorating-001.jpg
// module id = 96
// module chunks = 0